import OfferTimer from './OfferTimer.jsx';
import { GRADIENT_BTN } from './shared.js';
import { t } from '../../../i18n/strings.js';

export default function OfferHeader({ timerLabel, onGetPlan }) {
  return (
    <div className="sticky top-0 z-20 bg-bg/95 backdrop-blur px-5 pt-3 pb-2 flex items-center justify-between">
      <OfferTimer label={t('paywallIntl.offerReserved')} timerLabel={timerLabel} />
      <button
        onClick={onGetPlan}
        className="fc-cta-pulse h-14 px-6 rounded-2xl font-display font-extrabold text-[15px] text-bg active:scale-[0.97] transition-transform"
        style={{ background: GRADIENT_BTN, boxShadow: '0 6px 20px rgba(25,215,242,0.35)' }}
      >
        {t('paywallIntl.getPlan')}
      </button>
    </div>
  );
}
